module.exports = __webpack_public_path__ + "static/Reef-dfe7ac34da276f9b4b84f78f975d1018.png";